import { createApp } from 'vue';
import App from './App.vue';
import { installBootHardening, mountEntrApp } from './app/bootHardening';
import { DEFAULT_LOCALE, i18n, setEntrLocale } from './i18n';
import {
  getKioskSlug,
  getLegacyLaunchState,
  getRuntimeUrlState,
  persistLaunchCredentials,
  replaceLegacyLaunchWithBootstrapPath,
  replaceWithCanonicalKioskUrl,
} from './services/urlState';
import {
  initSentry,
  setSentryKiosk,
  setSentryLocale,
} from './telemetry/sentry';
import './ui/styles/tokens.css';
import './ui/styles/base.css';

const legacyLaunchState = getLegacyLaunchState();
if (legacyLaunchState) {
  replaceLegacyLaunchWithBootstrapPath(legacyLaunchState.slug);
}

persistLaunchCredentials(legacyLaunchState?.slug ?? getKioskSlug());

let runtimeUrlState = getRuntimeUrlState();
const launchSlug = runtimeUrlState.slug ?? getKioskSlug();
const launchLocale = runtimeUrlState.locale ?? DEFAULT_LOCALE;
setEntrLocale(launchLocale);

replaceWithCanonicalKioskUrl(launchLocale);
runtimeUrlState = getRuntimeUrlState();

const app = createApp(App);

app.use(i18n);
initSentry(app);
installBootHardening(app);
setSentryLocale(launchLocale);
setSentryKiosk({
  slug: runtimeUrlState.slug ?? launchSlug,
  kioskId: runtimeUrlState.kioskId,
  // Preserve the full launch API key in Sentry context; it is an internal
  // machine join key that maps directly to the Postgres kiosk config row.
  apiKey: runtimeUrlState.apiKey,
});

mountEntrApp(app);
